<div *ngIf="showQuestionReview" class="raptor-question-review" [class]="(element.settings && element.settings.align)">
  <div [ngSwitch]="element.type" [class]="(element.settings && element.settings.size)">
    <ng-container *ngSwitchCase="'repeater'">
      <div
        *ngFor="let repeaterData of element.data; let dataIndex = index"
        class="raptor-question-review-repeater-group-container"
        [ngClass]="{'padding-bottom-medium margin-bottom-medium': dataIndex !== element.data.length - 1}">

        <ng-container *ngFor="let childElement of element.elements">
          <open-raptor-question-review
            [element]="getRepeaterElementDetails(childElement, element, dataIndex)"
            [form]="form"
            [context]="context"
          ></open-raptor-question-review>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'extras'">
      <div
        class="raptor-question-review-container flex flex-content-center"
        [ngClass]="{'padding-vertical-none': context !== 'sidebar',  'padding-bottom-xxsmall': context === 'sidebar', 'sidebar-container': context === 'sidebar'}">
        <label [attr.for]="element.key" class="small flex">
          {{ element.review_label || element.prompt }}
        </label>

        <div class="raptor-question-review-value flex-grow text-small text-right" *ngIf="extras && extras.length">
          <div *ngFor="let extra of extras; let last = last">
            <div>{{ extra.text }}</div>
          </div>
        </div>
        <div class="raptor-question-review-value flex-grow text-small text-right" *ngIf="!extras || !extras.length">
          <div>None</div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'upgrade'">
      <div class="upgrade-question padding-top-medium" [class]="element.style">
        <div class="tile-container margin-bottom-small">
          <div class="included-badge">
            <span class="text-capsule medium strong-small">{{ element.caption }}</span>
          </div>
          <div class="toggle-icon">
            <open-svg-icon name="{{ element.icon }}" class="small"></open-svg-icon>
          </div>
          <div class="toggle-label">
            <b class="label">{{ element.prompt }}
            </b>
            <p class="text-small" [innerHTML]="element.subtext"></p>
          </div>
          <div class="toggle-input">
            <button mat-stroked-button color="secondary" type="button" (click)="onEditQuestionClick(element.key)">Upgrade</button>
          </div>
          <span *ngIf="element.help && (!element.help.type || element.help.type === 'tooltip')" class="tooltip">
            <open-tooltip [tooltipContent]="element.help.content"></open-tooltip>
          </span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <div class="margin-bottom-small" *ngIf="element.info && (element.info.settings && element.info.settings.show_info && element.info.settings.align === 'top')">
        <open-raptor-info [info]="element.info" [form]="form"></open-raptor-info>
      </div>

      <div
        class="raptor-question-review-container flex flex-content-center"
        [ngClass]="{'padding-vertical-none': context !== 'sidebar',  'padding-bottom-xxsmall': context === 'sidebar', 'sidebar-container': context === 'sidebar'}"
      >
        <label [attr.for]="element.key" class="small flex">
          {{ element.review_label || element.prompt }}
        </label>

        <div [id]="element.key" class="raptor-question-review-value flex-grow text-small text-right">
          <ng-container *ngIf="element.human">{{ element.human }}</ng-container>

          <ng-container *ngIf="!element.human">
            <ng-container [ngSwitch]="element.type">
              <span *ngSwitchCase="'number'">
                <ng-container *ngIf="element.settings?.format === 'currency'"><span [innerHTML]="applyCurrency(element)"></span></ng-container>
                <ng-container *ngIf="element.settings?.format !== 'currency'">{{ element.data | number: '1.0-0' }}</ng-container>
              </span>
              <span *ngSwitchCase="'currency'" [innerHTML]="applyCurrency(element)"></span>
              <span *ngSwitchDefault>{{ element.data }}</span>
            </ng-container>
          </ng-container>

        </div>

        <span *ngIf="context !== 'sidebar'">
          <button *ngIf="(!(element.mode && element.mode === 'summary') && (!(element.settings && element.settings.read_only)))" mat-icon-button color="primary" class="mat-icon-button small margin-left-xsmall" type="button" (click)="onEditQuestionClick(element.key)">
            <mat-icon class="material-icons-outlined create_outline" aria-hidden="false" aria-label="edit"></mat-icon>
          </button>
          <span *ngIf="(element.mode && element.mode === 'summary')  && (!(element.settings && element.settings.read_only))" class="edit-spacer"></span>
        </span>
      </div>

      <div class="margin-top-small" *ngIf="element.info && (element.info.settings && element.info.settings.show_info && element.info.settings.align !== 'top')">
        <open-raptor-info [info]="element.info" [form]="form"></open-raptor-info>
      </div>
    </ng-container>
  </div>
</div>
